import { RadioGroup } from "@equidefi/ui/forms";
import type { RadioGroupProps } from "@equidefi/ui/forms/RadioGroup";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

export type SmartRadioGroupProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<RadioGroupProps, "value" | "onChange"> & {
  name: TName;
};

function SmartRadioGroup<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...radioProps }: SmartRadioGroupProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const { field } = useController<TFieldValues, TName>({ name, control });

  return <RadioGroup value={field.value as string | number | boolean} onChange={field.onChange} {...radioProps} />;
}

export default SmartRadioGroup;
